import { render, staticRenderFns } from "./TableauEmbedded.vue?vue&type=template&id=4db9471a&scoped=true&"
import script from "./TableauEmbedded.vue?vue&type=script&lang=js&"
export * from "./TableauEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./TableauEmbedded.vue?vue&type=style&index=0&id=4db9471a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9471a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VRow})
